var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 5.3125C15.4688 5.3125 15.75 5.59375 15.75 5.875V6.4375C15.75 6.75391 15.4688 7 15.1875 7H0.5625C0.246094 7 0 6.75391 0 6.4375V5.875C0 5.59375 0.246094 5.3125 0.5625 5.3125H2.21484C2.46094 3.44922 3.83203 1.90234 5.66016 1.51562C5.87109 0.777344 6.50391 0.25 7.3125 0.25H9.5625C10.4766 0.25 11.25 1.02344 11.25 1.9375C11.25 2.88672 10.4766 3.625 9.5625 3.625H7.3125C6.82031 3.625 6.39844 3.44922 6.11719 3.13281C4.99219 3.37891 4.11328 4.25781 3.90234 5.3125H15.1875ZM14.0625 16.5625C14.3438 16.5625 14.625 16.8438 14.625 17.125V17.6875C14.625 18.0039 14.3438 18.25 14.0625 18.25H1.6875C1.37109 18.25 1.125 18.0039 1.125 17.6875V17.125C1.125 16.8438 1.37109 16.5625 1.6875 16.5625H3.02344L2.25 8.125H13.5L12.6914 16.5625H14.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.4eb30be32929d952fcb6492ea1fc744c.svg";
export { ForwardRef as ReactComponent };